import script from "./mainBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./mainBackground.vue?vue&type=script&setup=true&lang=js"

import "./mainBackground.vue?vue&type=style&index=0&id=7fec270c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fec270c"]])

export default __exports__